import React, { Component } from 'react';
import moment from 'moment';
import Icon from './Icon';

// Import the CSS
import '../../scss/components/_calendar.scss';

export default class Calendar extends Component {
	constructor (props) {
		super(props);

		let date = this.formatSelectedDate(props.selectedDate) || moment();

		this.state = {
			currentDate: date,
			selectedDate: date,
		};

	}

	formatSelectedDate (selectedDate) {

		if (selectedDate) {

			selectedDate = selectedDate.replace(/[^0-9\/]/g, '');

			if (selectedDate.length === 4) {
				selectedDate = moment(selectedDate, 'YYYY');
			} else if (selectedDate.length === 6) {
				selectedDate = moment(selectedDate, 'YYYY/M');
			} else if (selectedDate.length === 7) {
				selectedDate = moment(selectedDate, 'YYYY/MM');
			} else if (selectedDate.length === 9) {
				selectedDate = moment(selectedDate, 'YYYY/MM/D');
			} else if (selectedDate.length === 10) {
				selectedDate = moment(selectedDate, 'YYYY/MM/DD');
			} else {
				return null;
			}

			// Return the formatted date if it's valid.
			if (selectedDate.isValid()) {
				return selectedDate;
			}

		}

		return null;
	}

	componentWillReceiveProps (props) {

		let selectedDate = this.formatSelectedDate(props.selectedDate);

		if (selectedDate) {
			this.setState({ selectedDate: selectedDate });
		}
	}

	handleClickPrevMonth (e) {
		e.preventDefault();

		this.setState({ currentDate: moment(this.state.currentDate).subtract(1, 'month') });
	}

	handleClickNextMonth (e) {
		e.preventDefault();

		this.setState({ currentDate: moment(this.state.currentDate).add(1, 'month') });
	}

	handleClickDate (e, date) {
		e.preventDefault();

		if (this.props.onSelectDate) {
			this.props.onSelectDate(date);
		}
	}

	render () {

		let selectedDate = this.state.selectedDate;
		let currentDate = this.state.currentDate;
		let monthName = currentDate.format('MMMM');
		let firstDayDate = moment(currentDate).startOf('month');
		let lastDayDate = moment(currentDate).endOf('month');
		let startOffset = firstDayDate.day();
		let endOffset = 6 - lastDayDate.day();
		let dates = [];

		// Populate the days for the previous month (if any)
		for (let offset = startOffset; offset > 0; offset--) {
			dates.push(moment(firstDayDate).subtract(offset, 'days'));
		}

		// Populate the days for the selected month
		for (let day = 1; day <= currentDate.daysInMonth(); day++) {
			dates.push(moment([ currentDate.year(), currentDate.month(), day ]));
		}

		// Populate the days for the next month (if any)
		for (let offset = 1; offset <= endOffset; offset++) {
			dates.push(moment(lastDayDate).add(offset, 'days'));
		}

		return (
			<div className="calendar">
				<div className="calendar-header">
					<a href="#" className="calendar-prev" onClick={ e => this.handleClickPrevMonth(e) }><Icon type="chevron-left" /></a>
					<h1>
						{ monthName }
						<small>{ currentDate.year() }</small>
					</h1>
					<a href="#" className="calendar-next" onClick={ e => this.handleClickNextMonth(e) }><Icon type="chevron-right" /></a>
				</div>
				<div className="">
				</div>
				<div className="calendar-dates">
					{ dates.map(date => {

						let classes = [ 'calendar-day' ];

						if (date.isSame(selectedDate, 'day')) {
							classes.push('selected');
						} else if (!date.isSame(currentDate, 'month')) {
							classes.push('calendar-day-gray');
						}

						return (
							<div key={ date.format() } className={ classes.join(' ') }>
								<a href="#" onClick={ e => this.handleClickDate(e, date) }>{ date.date() }</a>
							</div>
						);
					}) }
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Calendar.js